import axios from 'axios';

export const uploadFileToUrl = async ({
  url,
  file,
  headers,
  onProgress,
}: {
  url: string;
  file: File;
  headers?: Record<string, string>;
  onProgress?: (progress: number) => void;
}) => {
  return await axios.put(url, file, {
    headers: {
      'Content-Type': file.type,
      'X-Goog-Content-Length-Range': `0,${50 * 1024 * 1024}`,
      ...headers,
    },
    onUploadProgress: (progressEvent) => {
      if (!progressEvent.progress) {
        onProgress?.(0);
        return;
      }
      onProgress?.(progressEvent.progress * 100);
    },
  });
};
